import { AppConfig } from 'AppConfig';
import Auth from 'auth/Auth';
import { DYNAMIC_REPORT_ROUTES, REPORT_URL_REGEX_PATTERNS } from 'common/Constant';
import { CLEAN_SESSION } from 'features/masterData/util/CommonUtil';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { LOGOUT } from 'features/user/userTypes';
import routePaths from 'routes/routePaths';
import LocalStore from 'utils/LocalStore';
import { getDynamicRouteParams, isMatch } from 'utils/common';

const Login = () => {
  const annualRenewalPath = routePaths.clientPortal + AppConfig.CLIENT_PORTAL_SUB_URL.ANNUAL_PLAN_RENEWAL;
  const location = useLocation();
  const fromUrl = location?.state?.from?.pathname || '';

  if (fromUrl && fromUrl === annualRenewalPath) {
    LocalStore.setCaseRenewalRedirectUrl(fromUrl);
  } else if (isMatch(fromUrl, REPORT_URL_REGEX_PATTERNS)) {
    const routeParams = getDynamicRouteParams(fromUrl, DYNAMIC_REPORT_ROUTES);
    LocalStore.setReportTenantCode(routeParams?.tenantCode);
    LocalStore.setReportsRedirectUrl(fromUrl);
  }

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const clientPortalUrl = AppConfig.OKTA_CLIENT_PORTAL_URL;
    if (Auth.getLoginMode() !== Auth.LOGIN_MODE_BST) {
      CLEAN_SESSION();
      Auth.setLoginMode(Auth.LOGIN_MODE_BST);
    }

    const jwt = LocalStore.getAccessToken();

    if (jwt) {
      navigate(routePaths.newHome);
      return;
    }

    dispatch({ type: LOGOUT });
    // Redirect the user to the new client portal login page
    window.location.href = clientPortalUrl;
  }, [dispatch, navigate]);

  // Highlighted: Removed loginToFo and Clarity Integration
  return null;
};

export default Login;
